import React from 'react';
import './DesktopLeft.css';
import Header from './Header';
import GameCarousel from './GameCarousel';
import WishlistSection from './WishlistSection';

const DesktopLeft: React.FC = () => {
  return (
    <div className="desktop-left">
      <Header isMobile={false} />
      <GameCarousel isMobile={false} />
      <WishlistSection isMobile={false} />
    </div>
  );
};

export default DesktopLeft;